<template>
  <!-- TODO: get it back after removing the Backbone user bar -->
  <div class="quick-launch" v-if="quickLaunchButtonDisplay">
    <div class="quick-launch-switch" ref="quickLaunchSwitch" @click="toggleMenu" v-on:keyup.enter="toggleMenu" :title="quickLaunchTooltip"
         :tooltip-text="quickLaunchTooltip" tooltip-position="right" tooltip-align="middle" role="button" tabindex="0" :aria-label="quickLaunchTooltip" :aria-expanded="setAriaExpanded()">
      <div class="quick-launch-icon ico-app-launch" :class="{'clicked': menuVisible }"></div>
    </div>
    <div id="quick-launch-dropdown" ref="quickLaunchDropdown" :style="{ display: menuDisplay }" class="quick-launch-dropdown" tabindex="-1" :aria-label="quickLaunchTooltip">

      <div class="quick-launch-dropdown-container">
        <quick-launch-link ref="quickLaunchItem" v-for="(link, index) in getAppsToDisplay" :title="link.title" :aria-label="link.title" tooltip-position="right" tooltip-align="middle" :class="{'odd': index % 2 !== 0}"
                           :url="link.url" :iconURL="link.iconURL" @clicked="hideMenu" :key="index" role="button" tabindex="0"></quick-launch-link>
      </div>
      <div class="quick-launch-show-more" ref="quickLaunchShowMore" v-if="showMoreAppsButton">
        <a role="button" tabindex="0" v-on:keyup.enter="showMoreClicked" v-on:keyup.space="showMoreClicked" v-on:click="showMoreClicked">{{getQuickLaunchShowMoreText}}</a>
      </div>
      <div class="quick-launch-buttons-container"  ref="quickLaunchButtonsContainer">
        <quick-launch-marketing-link v-for="(link, index) in marketingLinks" :title="link.title" :aria-label="link.title" :url="link.url"
                                     :iconURL="link.iconURL" @clicked="hideMenu" :key="index" role="button" tabindex="0" v-on:keyup.enter="hideMenu" v-on:keyup.space="hideMenu"></quick-launch-marketing-link>
      </div>
    </div>
  </div>
</template>

<script>

  const MIN_COL_COUNT = 3;
  const INITIAL_MAX_APP = 9;
  const QUICK_LUNCH_BOTTOM_PADDING = 20;
  const QUICK_LUNCH_TOP_PADDING = 10;
  const TOP_BAR_HEIGHT = 55;

  import * as ApiResources from 'assets/data/apiResources.json';
  import * as CONST from 'const';
  import urlResolver from "urlResolver";
  import CompoundFeatureIds from "assets/constants/compound-features-ids.json"
  import QuickLaunchLink from "./QuickLaunchLink"
  import QuickLaunchMarketingLink from "./QuickLaunchMarketingLink"
  import LEConfig from 'assets/config/le-env-conf';

  import {
    sessionManager,
    Logger,
    BaseClient
  } from "vue-infra";

  const applicationType = {
    REGULAR: 0,
    MARKETING: 1
  };

  const componentName = 'quickLaunch';
  const logger = Logger.getLogger('LiveEngage:QuickLaunch');

  export default {
    name: componentName,
    components: {
      QuickLaunchLink,
      QuickLaunchMarketingLink
    },
    created: function () {
      document.addEventListener('click', this.checkForOutsideClick);
      this.getQuickLaunchCollection();
    },
    mounted() {
        this.setQuickLaunchDropdownWidth();
    },
    destroyed: function() {
    document.removeEventListener('click', this.checkForOutsideClick);
    },
    data: function () {
      return {
        menuVisible: false,
        menuStateClass: 'closed',
        links: [],
        marketingLinks: [],
        quickLaunchTooltip: this.$translator.translate('LEFramework.userBarMenu.quickLaunch.tooltip'),
        quickLaunchApps: [],
        showMoreApps: false
      }
    },
    computed: {
      menuDisplay() {
        return this.menuVisible ? 'block' : 'none';
      },
      quickLaunchButtonDisplay() {
        return (this.isAcFeatureEnabled() && this.getApplicationCount() > 0);
      },
      getAppsToDisplay() {
        return this.showMoreApps ? this.links : this.links.slice(0, INITIAL_MAX_APP);
      },
      showMoreAppsButton(){
        return this.getApplicationCount() > INITIAL_MAX_APP
      },
      getQuickLaunchShowMoreText(){
        return this.showMoreApps ? this.$translator.translate('LEFramework.userBarMenu.quickLaunch.seeLess') : this.$translator.translate('LEFramework.userBarMenu.quickLaunch.seeMore');
      }
    },
    methods: {
      setAriaExpanded() {
        if(this.menuVisible){
          return "true";
        } else {
          return "false";
        }
      },
      setQuickLaunchDropdownWidth() {
        //check if the elements created
        if (typeof this.$refs.quickLaunchItem === 'undefined') {
            return;
        }

        //check if there is any quickLaunchItem item
        if (this.$refs.quickLaunchItem.length == 0) {
            return;
        }


        const itemHeight = this.$refs.quickLaunchItem[0].$el.clientHeight;
        const itemWidth = this.$refs.quickLaunchItem[0].$el.clientWidth;
        const showMoreBtnHeight = this.showMoreAppsButton ? this.$refs.quickLaunchShowMore.clientHeight : 0;
        const quickLaunchButtonsContainerHeight = this.marketingLinks.length > 0 ? this.$refs.quickLaunchButtonsContainer.clientHeight : 0;
        let maxHeight = (
            window.innerHeight - //all window height
            QUICK_LUNCH_BOTTOM_PADDING -
            QUICK_LUNCH_TOP_PADDING -
            TOP_BAR_HEIGHT -
            showMoreBtnHeight -
            quickLaunchButtonsContainerHeight);

        const maxRowCount = Math.floor(maxHeight/itemHeight);
        let maxColCount = Math.max(Math.ceil(this.getAppsToDisplay.length / maxRowCount), MIN_COL_COUNT);
        if (maxColCount>this.getAppsToDisplay.length) {
          maxColCount = this.getAppsToDisplay.length;
        }
        this.$refs.quickLaunchDropdown.style.width = (maxColCount * itemWidth) + 'px';
      },
      extendQuickLaunchApps() {
        this.links = [];
        this.marketingLinks = [];
        if (this.quickLaunchApps.length > 0){
          this.quickLaunchApps.map(app => {
            switch (app.appType) {
              case applicationType.REGULAR:
              default:
                this.links.push({
                  title: app.display_name,
                  iconURL: decodeURIComponent(app.logo_uri),
                  url: this.appendBrandID(decodeURIComponent(app.entry_uri)),
                });
                break;
              case applicationType.MARKETING:
                this.marketingLinks.push({
                  title: app.display_name,
                  iconURL: decodeURIComponent(app.logo_uri),
                  url: this.appendBrandID(decodeURIComponent(app.entry_uri)),
                });
                break;
            }
          });
        }

        //add report builder if there is permission
        this.addReportBuilderIfNeeded();
      },
      hideMenu() {
        this.menuStateClass = 'closed';

        setTimeout(() => {
            this.menuVisible = false;
            this.showMoreApps = false;
            this.setQuickLaunchDropdownWidth();
        }, 400);
        setTimeout(() => this.$refs.quickLaunchSwitch.focus(), 250);
      },
      showMenu() {
        this.menuVisible = true;
        setTimeout(() => {
          this.menuStateClass = 'open';
          this.setQuickLaunchDropdownWidth();
        }, 100);
        setTimeout(() => this.$refs.quickLaunchDropdown.focus(), 250);
        logger.bam({
          serviceName: 'CCUI-CORE',
          appName: 'CCUI',
          eventName: 'open cc applications',
          widgetName: 'cc-applications',
          countValue: this.getAppsToDisplay.length,
          context: this.getAppsToDisplay.map(link => link.title).join(', '),
        });
      },

      toggleMenu() {
        if (this.menuVisible) {
          this.hideMenu();
        }
        else {
          this.showMenu();
        }
      },
      checkForOutsideClick(event) {
        if (this.menuVisible && !this.$el.contains(event.target)) {
          this.hideMenu();
        }
      },
      async getQuickLaunchCollection() {
        // check if LEApps.QuickLaunchMenuButton feature flag enabled
        if (!this.isAcFeatureEnabled()) {
          return;
        }

        const domain = sessionManager.getCsdsServiceURI('appMgmtSvcDomain');
        let url = urlResolver.getUrl(ApiResources.AccountConfig.QuickLaunch.url, {
          appMgmtSvcDomain: domain,
          accountId: sessionManager.getAccountId(),
        });
        const client = new BaseClient({ config: { baseURL: url } });
        try{
          const res = await client.get('');
          this.quickLaunchApps = res.data;
          this.extendQuickLaunchApps();
        } catch (error) {

        }
      },

      addReportBuilderIfNeeded() {
        if (this.showReportBuilder()) {
          //Added the Report builder in index 0 to be the first
          this.links.splice(0, 0, {
            title:this.$translator.translate("LEReporting.DB_filters_reportBuilderLink_tooltip"),
            iconURL:this.buildReportBuilderIconUrl(),
            url: this.buildReportBuilderUrl()
          });
        }
      },
      extendQuickLaunchAppsError() {
        // logger.debug("Failed fatching Brand/User applications");
      },
      showReportBuilder() {
        return (LE.sessionManager.hasReportBuilderAccessFeature() &&
          (LE.sessionManager.getConfig().isLPA ||
            (LE.sessionManager.hasReportBuilderNonLpaAccessFeature() &&
            LE.sessionManager.hasPrivilege([LE.sessionManager.PRIVILEGES.VIEW_REPORTS_IN_REPORT_BUILDER, LE.sessionManager.PRIVILEGES.CUSTOMIZE_REPORTS_IN_REPORT_BUILDER, LE.sessionManager.PRIVILEGES.SHARE_REPORTS_IN_REPORT_BUILDER], true))));
      },
      buildReportBuilderUrl() {
        let url = '';
        const accountId = sessionManager.getAccountId();
        let doesAccountSupportSSO = false;
        if (LEConfig.reportBuilderFixAccounts.indexOf('*') >= 0 ||
            LEConfig.reportBuilderFixAccounts.indexOf(accountId) >= 0) {
            doesAccountSupportSSO = true;
        }
        if(LEConfig.isReportBuilderSupportSSO === true && doesAccountSupportSSO) {
            const domain = sessionManager.getCsdsServiceURI('leRBMstr');
            url = urlResolver.getUrl(ApiResources.DataMarketer.ReportBuilderQuickLaunch.url, {
                leRBMstr: domain,
                accountId: sessionManager.getAccountId(),
            });
        } else {
            const accountTypeValue = (CONST.SOURCE_ENUM.LEGACY ===
                LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.USERS_SOURCE)) ?
                0 : 1;
            const domain = sessionManager.getCsdsServiceURI('adminArea');
            url = urlResolver.getUrl(ApiResources.DataMarketer.ReportBuilderQuickLaunchOld.url, {
                    adminArea: domain,
                    accountId: sessionManager.getAccountId(),
                    wsuk: sessionManager.getWsuk(),
                    locale: LE.siteSettings.languageSettings.getExternalReportingLocale(),
                    accountype: accountTypeValue,
                    isAGused: LE.sessionManager.hasAgentGroupsFeature() ? 1 : 0
                });
        }

        return url;
      },
      buildReportBuilderIconUrl(){
        const domain = sessionManager.getCsdsServiceURI('leCdnDomain');
        let url = urlResolver.getUrl(ApiResources.DataMarketer.ReportBuilderQuickLaunchIcon.url, {
          leCdnDomain: domain,
        });
        return url;
      },
      getApplicationCount() {
          if ((this.links === undefined || this.links === null)){
              return 0;
          } else {
              return this.links.length;
          }
      },
      appendBrandID(entry_uri) {
        return entry_uri.indexOf('?') !== -1 ? entry_uri + "&accountId=" + sessionManager.getAccountId(): entry_uri + "?accountId=" + sessionManager.getAccountId();
      },
      isAcFeatureEnabled() {
        return LE.sessionManager.getFeaturePropertyState(CompoundFeatureIds.QUICK_LAUNCH_BUTTON_MENU_ENABLED);
      },
      showMoreClicked(){
        this.showMoreApps = !this.showMoreApps;

        this.setQuickLaunchDropdownWidth();
        if (this.showMoreApps) {
          logger.bam({
            serviceName: 'CCUI-CORE',
            appName: 'CCUI',
            eventName: 'see more cc applications',
            widgetName: 'cc-applications',
            countValue: this.getApplicationCount(),
            context: this.links.map(link => link.title).join(', '),
          });
        }
      }
    },

  };

</script>

<style lang='scss' scoped>
  @import "../../../../assets/scss/global";
  @import "../../../../assets/scss/mixins";


  .quick-launch-switch {
    cursor: pointer;
    padding: 0 6px;
  }

  // load the hover state image to avoid image flicker....
  .quick-launch:before {
    @include lp-bg-image("assets/img/icn-menu-hover.svg");
    content: "";
    visibility: hidden;

  }

  .quick-launch-icon {
    width: 20px;
    height: 20px;
    font-size: 20px;
    @include themify {
      color: getColor('data-bar-icons-active', 'framework');
    }
    object-fit: contain;
  }

  .quick-launch-dropdown {
    transition: display 400ms;
    display: none;
    position: absolute;
    min-width: 100px;
    max-width: 1750px;
    min-height: 100px;
    max-height: max-content;
    height: max-content;
    bottom: 20px;
    left: 80px;
    z-index: 99999;
    padding: 20px 22px 15px 22px;
    @include themify {
      background-color: getColor('quick-launch-dropdown-bg-color', 'framework');
      border: solid 1px getColor('quick-launch-dropdown-border-color', 'framework');
    };

    @include border-radius(15px);
    @include themify {
      @include box-shadow(
          getSize('quick-launch-dropdown-shadow-color-h-offset', 'framework')
          getSize('quick-launch-dropdown-shadow-color-v-offset', 'framework')
          getSize('quick-launch-dropdown-shadow-color-blur', 'framework')
          getSize('quick-launch-dropdown-shadow-color-spread', 'framework')
          getColor('quick-launch-dropdown-shadow-color', 'framework'));

    }
    @include themify {
      // Triangle pseudo elements
      &:before {
        position: absolute;
        bottom: 60px;
        left: -29px;
        display: inline;
        vertical-align: middle;
        zoom: 1;
        border-right: 11px solid transparent;
        border-bottom: 12px solid getColor('quick-launch-dropdown-border-color', 'framework');
        border-left: 11px solid transparent;
        content: '';
        transform: translate(50%, -50%) rotate(-90deg);
      }
      &:after {
        position: absolute;
        bottom: 60px;
        left: -25px;
        display: inline;
        vertical-align: middle;
        zoom: 1;
        border-right: 10px solid transparent;
        border-bottom: 12px solid getColor('quick-launch-dropdown-bg-color', 'framework');
        border-left: 10px solid transparent;
        content: '';
        transform: translate(50%, -50%) rotate(-90deg);
      }
    };

    &.no-marketing {
      bottom: 68px;
      &:before {
        bottom: 15px !important;
      }
      &:after {
        bottom: 15px !important;
      }
    }
  }

  .quick-launch-dropdown.open {
    opacity: 1;
  }

  .quick-launch-dropdown.closed {
    opacity: 0;
  }

  .quick-launch-dropdown-container {
    display: flex;
    flex-flow: row wrap;
    overflow: auto;
    transform: scaleY(-1);
  }

  .quick-launch-show-more{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    @include themify {
      color: getColor('quick-launch-dropdown-border-color', 'framework');
    };
    text-align: center;
    padding: 10px;
  }
  .quick-launch-show-more a {
    font-family: Roboto;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-decoration: none;
    @include themify {
      color: getColor('quick-launch-dropdown-border-color', 'framework');
    }
    cursor: pointer;
  }


    .quick-launch-buttons-container{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
  }

  .show-more-button{
    opacity: 0.5;
    border-radius: 8px;
    border: solid 1.5px #ffffff;
    background-color: rgba(0, 0, 0, 0.2);
    font-family: Roboto;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

</style>




